const getDefaultState = () => {
  return {
    optionsPersonType: [],
    optionsIdentificationType: [],
    optionsCountries: [],
    optionsCountriesAbrevs: [],
    optionsDepartments: [],
    optionsCity: [],
    optionsGender: [],
    optionsChannel: [],
    optionsProducts: [],
    optionsReasons: [],
    optionsControlEntity: [],
    optionsConditions: [],
    optionsStates: [],
    optionsStatesAgilizaCf: [],
    optionsStatesAgilizaEv: [],
    optionsCompanies: [],
    optionsCriterions: [],
    optionsGroupCompany: [],
    optionsPosition: [],
    optionsCompanyType: [],
    optionsDirections: [],
    optionsReception: [],
    optionsFraudTypes: [],
    optionsFraudModes: [],
    optionsDuplicityStates: [],
    optionsStatesSolip: [],
    optionsStatesAnnexesSolip: [],
    optionsTypeAnalisis: [],
    optionsTypeMlValidation: [],
    optionsTypeRequestSolip: [],
    optionsTypeProblem: [],
    optionsStateTechnicalSupport: [],
    optionsReasonsAgiliza: [],
    optionsCompanyEmisor: [],
    optionsTypeValueEmisor: [],
    optionsReasonsEmisor: [],
    optionsStatesEmisor: [],
    optionsEntityType: [],
    optionsMannedCheckpoint: [],
    optionsTypeNotifications: [],
    optionsStateNotifications: [],
    optionsWithdrawAgiliza: [],
    optionsAllCompanies: [],
    optionsRadicatorProfile: [],
    optionsSolitudeDpHd: [],
    optionsAvailableDay: [],
    optionsSessionDurationAgiliza: [],
    optionsStatesFacilitators: [],
    optionsStatesSessionsFacilitator: [],
    optionsStatesSessionsCf: [],
    optionsStatesSessionsEv: [],
    optionsTypeNotifySfc: [],
    optionsLgbtiq: [],
  };
};

const state = getDefaultState;

const mutations = {
  setFormOptions(state, payload) {
    state.optionsPersonType = payload.optionsPersonType;
    state.optionsIdentificationType = payload.optionsIdentificationType;
    state.optionsTypeProblem = payload.optionsTypeProblem;
    state.optionsStateTechnicalSupport = payload.optionsStateTechnicalSupport;
    state.optionsTypeNotifications = payload.optionsTypeNotifications;
    state.optionsStateNotifications = payload.optionsStateNotifications;
    state.optionsCountries = payload.optionsCountries;
    state.optionsCountriesAbrevs = payload.optionsCountriesAbrevs;
    state.optionsDepartments = payload.optionsDepartments;
    state.optionsCity = payload.optionsCity;
    state.optionsReasonsAgiliza = payload.optionsReasonsAgiliza;
    state.optionsCompanyEmisor = payload.optionsCompanyEmisor;
    state.optionsTypeValueEmisor = payload.optionsTypeValueEmisor;
    state.optionsReasonsEmisor = payload.optionsReasonsEmisor;
    state.optionsStatesEmisor = payload.optionsStatesEmisor;
    state.optionsEntityType = payload.optionsEntityType;
    state.optionsMannedCheckpoint = payload.optionsMannedCheckpoint;
    state.optionsWithdrawAgiliza = payload.optionsWithdrawAgiliza;
    state.optionsAllCompanies = payload.optionsAllCompanies;
    state.optionsRadicatorProfile = payload.optionsRadicatorProfile;
    state.optionsSolitudeDpHd = payload.optionsSolitudeDpHd;
  },
  setComplaintOptions(state, payload) {
    state[Object.keys(payload)[0]] = Object.values(payload)[0];
  },
  setDashboardOptions(state, payload) {
    state.optionsCriterions = payload.optionsCriterions;
    state.optionsPosition = payload.optionsPosition;
    state.optionsGroupCompany = payload.optionsGroupCompany;
    state.optionsCompanyType = payload.optionsCompanyType;
    state.optionsDirections = payload.optionsDirections;
    state.optionsReception = payload.optionsReception;
    state.optionsFraudTypes = payload.optionsFraudTypes;
    state.optionsFraudModes = payload.optionsFraudModes;
    state.optionsEntityType = payload.optionsEntityType;
    state.optionsMannedCheckpoint = payload.optionsMannedCheckpoint;
    state.optionsRadicatorProfile = payload.optionsRadicatorProfile;    
    state.optionsSolitudeDpHd = payload.optionsSolitudeDpHd;
    state.optionsAllCompanies = payload.optionsAllCompanies;
    state.optionsAvailableDay = payload.optionsAvailableDay;
    state.optionsSessionDurationAgiliza = payload.optionsSessionDurationAgiliza;
    state.optionsStatesFacilitators = payload.optionsStatesFacilitators;
    state.optionsStatesSessionsFacilitator = payload.optionsStatesSessionsFacilitator;
    state.optionsStatesSessionsCf = payload.optionsStatesSessionsCf;
    state.optionsStatesSessionsEv = payload.optionsStatesSessionsEv;
    state.optionsTypeNotifySfc = payload.optionsTypeNotifySfc;
    state.optionsStateNotifications = payload.optionsStateNotifications;
    state.optionsLgbtiq = payload.optionsLgbtiq;
  },
  setListOptions(state, payload) {
    state[payload.listName] = payload.listData;
  },
};
const actions = {
  // Load all form options for USER REGISTRATION
  loadFormOptions({ commit, dispatch }) {
    let baseUrl = this._vm.$apiBase.defaults.baseURL;
    let countries = dispatch("loadOptions", { url: baseUrl + "/api/country/" });
    let countriesAbrevs = dispatch("loadOptions", {
      url: baseUrl + "/api/countryabrevs/",
    });
    let optionsTypeProblem = dispatch("loadOptions", {
      url: baseUrl + "/api/type-problem-choices/",
    });
    let optionsStateTechnicalSupport = dispatch("loadOptions", {
      url: baseUrl + "/api/support-state/",
    });
    let identificationType = dispatch("loadOptions", {
      url: baseUrl + "/api/identificationtype/",
    });
    let personType = dispatch("loadOptions", {
      url: baseUrl + "/api/persontype/",
    });
    let departments = dispatch("loadOptions", {
      url: baseUrl + "/api/department/",
    });
    let optionsReasonsAgiliza = dispatch("loadOptions", {
      url: baseUrl + "/api/reason/?is_agiliza_reason=true",
    });
    let optionsCompanyEmisor = dispatch("loadOptions", {
      url: baseUrl + "/api/companyemisores/",
    });
    let optionsTypeValueEmisor = dispatch("loadOptions", {
      url: baseUrl + "/api/reasons-emisores-value/",
    });
    let optionsReasonsEmisor = dispatch("loadOptions", {
      url: baseUrl + "/api/reasons-emisores/",
    });
    let optionsStatesEmisor = dispatch("loadOptions", {
      url: baseUrl + "/api/state-emisores/",
    });
    let optionsEntityType = dispatch("loadOptions", {
      url: baseUrl + "/api/companyemisorestype/",
    });
    let optionsMannedCheckpoint = dispatch("loadOptions", {
      url: baseUrl + "/api/companyemisorescontrol/",
    });
    let optionsTypeNotifications = dispatch("loadOptions", {
      url: baseUrl + "/api/alerts/cf_type_alert/",
    });
    let optionsStateNotifications = dispatch("loadOptions", {
      url: baseUrl + "/api/alerts/cf_status_options/",
    });
    let optionsWithdrawAgiliza = dispatch("loadOptions", {
      url: baseUrl + "/api/complaint-agiliza-cancelation/",
    });
    let optionsAllCompanies = dispatch("loadOptions", {
      url: baseUrl + "/api/company_list/",
    });
    let optionsRadicatorProfile = dispatch("loadOptions", {
      url: baseUrl + "/api/radicatorprofile_options/",
    });
    let optionsSolitudeDpHd = dispatch("loadOptions", {
      url: baseUrl + "/api/jurisdiccional-servi/solicitude_type",
    });

    Promise.all([
      personType,
      identificationType,
      countries,
      departments,
      countriesAbrevs,
      optionsTypeProblem,
      optionsStateTechnicalSupport,
      optionsReasonsAgiliza,
      optionsCompanyEmisor,
      optionsTypeValueEmisor,
      optionsReasonsEmisor,
      optionsStatesEmisor,
      optionsEntityType,
      optionsMannedCheckpoint,
      optionsTypeNotifications,
      optionsStateNotifications,
      optionsWithdrawAgiliza,
      optionsAllCompanies,
      optionsRadicatorProfile,
      optionsSolitudeDpHd,
    ])
      .then((response) => {
        let optionsPersonType = response[0];
        let optionsIdentificationType = response[1].filter((identification) => {
          if (identification.name != "NIT") {
            return identification;
          }
        });
        let optionsCountries = response[2].map((item) => {
          return {
            ...item,
            id: item.code,
          };
        });
        let optionsDepartments = response[3].map((item) => {
          return {
            ...item,
            id: item.code,
          };
        });

        let optionsCountriesAbrevs = response[4].map((item) => {
          return {
            ...item,
            id: item.id,
          };
        });

        let optionsTypeProblem = response[5].map((item) => {
          return {
            ...item,
            id: item.id,
          };
        });

        let optionsStateTechnicalSupport = response[6].map((item) => {
          return {
            ...item,
            id: item.id,
          };
        });

        let optionsReasonsAgiliza = response[7].map((item) => {
          return {
            ...item,
            id: item.id,
          };
        });

        let optionsCompanyEmisor = response[8].map((item) => {
          return {
            ...item,
            id: item.id,
          };
        });
        let optionsTypeValueEmisor = response[9].map((item) => {
          return {
            ...item,
            id: item.id,
          };
        });
        let optionsReasonsEmisor = response[10].map((item) => {
          return {
            ...item,
            id: item.id,
          };
        });
        let optionsStatesEmisor = response[11].map((item) => {
          return {
            ...item,
            id: item.id,
          };
        });

        let optionsEntityType = response[12].map((item) => {
          return {
            ...item,
            id: item.id,
          };
        });

        let optionsMannedCheckpoint = response[13].map((item) => {
          return {
            ...item,
            id: item.id,
          };
        });
        let optionsTypeNotifications = response[14].map((item) => {
          return {
            ...item,
            id: item.id,
          };
        });
        let optionsStateNotifications = response[15].map((item) => {
          return {
            ...item,
            id: item.id,
          };
        });
        let optionsWithdrawAgiliza = response[16].map((item) => {
          return {
            ...item,
            id: item.id,
          };
        });
        let optionsAllCompanies = response[17].map((item) => {
          return {
            ...item,
            id: item.id,
          };
        });
        let optionsRadicatorProfile = response[18].map((item) => {
          return {
            ...item,
            id: item.id,
          };
        });
        let optionsSolitudeDpHd = response[19].map((item) => {
          return {
            ...item,
            id: item.id,
          };
        });

        commit("setFormOptions", {
          optionsPersonType,
          optionsIdentificationType,
          optionsCountries,
          optionsDepartments,
          optionsCountriesAbrevs,
          optionsTypeProblem,
          optionsStateTechnicalSupport,
          optionsReasonsAgiliza,
          optionsCompanyEmisor,
          optionsTypeValueEmisor,
          optionsReasonsEmisor,
          optionsStatesEmisor,
          optionsEntityType,
          optionsMannedCheckpoint,
          optionsTypeNotifications,
          optionsStateNotifications,
          optionsWithdrawAgiliza,
          optionsAllCompanies,
          optionsRadicatorProfile,
          optionsSolitudeDpHd,
        });
      })
      .catch((e) => console.error(e));
  },
  // Load all form options for COMPLAINTS registration with TOKEN
  loadComplaintOptions({ commit, dispatch }) {
    let baseUrl = this._vm.$apiBase.defaults.baseURL;
    let companies = dispatch("loadOptions", {
      url: baseUrl + "/api/company/",
      auth: true,
    });
    let channel = dispatch("loadOptions", {
      url: baseUrl + "/api/channel/",
      auth: true,
    });
    let states = dispatch("loadOptions", {
      url: baseUrl + "/api/state/",
      auth: true,
    });
    let statesAgilizaCf = dispatch("loadOptions", {
      url: baseUrl + "/api/state-agiliza/?actor=cf",
      auth: true,
    });
    let statesSessionsCf = dispatch("loadOptions", {
      url: baseUrl + "/api/session-state/?actor=cf",
      auth: true,
    });
    let statesSessionsEv = dispatch("loadOptions", {
      url: baseUrl + "/api/session-state/?actor=ev",
      auth: true,
    });
    let statesAgilizaEv = dispatch("loadOptions", {
      url: baseUrl + "/api/state-agiliza/?actor=ev",
      auth: true,
    });
    let gender = dispatch("loadOptions", {
      url: baseUrl + "/api/gender/",
      auth: true,
    }); /*
    let duplicityStates = dispatch("loadOptions", {
      url: baseUrl + "/api/duplicity/",
      auth: true,
    });*/
    let product = dispatch("loadOptions", {
      url: baseUrl + "/api/product/",
      auth: true,
    });
    let reason = dispatch("loadOptions", {
      url: baseUrl + "/api/reason/",
      auth: true,
    });
    let reasonAgiliza = dispatch("loadOptions", {
      url: baseUrl + "/api/reason/?is_agiliza_reason=true",
      auth: true,
    });
    let optionsCompanyEmisor = dispatch("loadOptions", {
      url: baseUrl + "/api/companyemisores/",
      auth: true,
    });
    let optionsTypeValueEmisor = dispatch("loadOptions", {
      url: baseUrl + "/api/reasons-emisores-value/",
      auth: true,
    });
    let optionsReasonsEmisor = dispatch("loadOptions", {
      url: baseUrl + "/api/reasons-emisores/",
      auth: true,
    });
    let controlEntity = dispatch("loadOptions", {
      url: baseUrl + "/api/controlentity/",
      auth: true,
    });
    let conditions = dispatch("loadOptions", {
      url: baseUrl + "/api/condition/",
      auth: true,
    });
    let optionsTypeAnalisis = dispatch("loadOptions", {
      url: baseUrl + "/api/jurisdiccional-servi/analysis-types",
      auth: true,
    });
    let optionsTypeMlValidation = dispatch("loadOptions", {
      url: baseUrl + "/api/jurisdiccional-servi/mlvalidate-types",
      auth: true,
    });
    let optionsStatesSolip = dispatch("loadOptions", {
      url: baseUrl + "/api/jurisdiccional-servi/solicitude-status",
      auth: true,
    });
    let optionsStatesAnnexesSolip = dispatch("loadOptions", {
      url: baseUrl + "/api/jurisdiccional-servi/annexes-status",
      auth: true,
    });
    let optionsTypeRequestSolip = dispatch("loadOptions", {
      url: baseUrl + "/api/jurisdiccional-servi/solicitude-types",
      auth: true,
    });
    let entityTypes = dispatch("loadOptions", {
      url: baseUrl + "/api/companyemisorestype/",
      auth: true,
    });
    let mannedCheckpoints = dispatch("loadOptions", {
      url: baseUrl + "/api/companyemisorescontrol/",
      auth: true,
    });
    let optionsWithdrawAgiliza = dispatch("loadOptions", {
      url: baseUrl + "/api/complaint-agiliza-cancelation/",
      auth: true,
    });
    let optionsAllCompanies = dispatch("loadOptions", {
      url: baseUrl + "/api/company_list/",
      auth: true,
    });
    let radicatorProfiles = dispatch("loadOptions", {
      url: baseUrl + "/api/radicatorprofile_options/",
      auth: true,
    });
    let solitudeDpHd = dispatch("loadOptions", {
      url: baseUrl + "/api/jurisdiccional-servi/solicitude_type",
      auth: true,
    });
    let statesEmisor = dispatch("loadOptions", {
      url: baseUrl + "/api/state-emisores/",
      auth: true,
    });
    let options_lgbtiq = dispatch("loadOptions", {
      url: baseUrl + "/api/lgbtiq-choices/",
      auth: true,
    });
    channel.then((value) => {
      const optionsChannel = value;
      commit("setComplaintOptions", { optionsChannel });
    });
    states.then((value) => {
      const optionsStates = value;
      commit("setComplaintOptions", { optionsStates });
    });
    statesAgilizaCf.then((value) => {
      const optionsStatesAgilizaCf = value;
      commit("setComplaintOptions", { optionsStatesAgilizaCf });
    });
    
    statesSessionsCf.then((value) => {
      const optionsStatesSessionsCf = value;
      commit("setComplaintOptions", { optionsStatesSessionsCf });
    });
    statesSessionsEv.then((value) => {
      const optionsStatesSessionsEv = value;
      commit("setComplaintOptions", { optionsStatesSessionsEv });
    });

    statesAgilizaEv.then((value) => {
      const optionsStatesAgilizaEv = value;
      commit("setComplaintOptions", { optionsStatesAgilizaEv });
    });
    gender.then((value) => {
      const optionsGender = value;
      commit("setComplaintOptions", { optionsGender });
    }); /*
    duplicityStates.then((value) => {
      const optionsDuplicityStates = value;
      commit("setComplaintOptions", { optionsDuplicityStates });
    });*/
    product.then((value) => {
      const optionsProducts = value;
      commit("setComplaintOptions", { optionsProducts });
    });
    reason.then((value) => {
      const optionsReasons = value;
      commit("setComplaintOptions", { optionsReasons });
    });
    reasonAgiliza.then((value) => {
      const optionsReasonsAgiliza = value;
      commit("setComplaintOptions", { optionsReasonsAgiliza });
    });
    controlEntity.then((value) => {
      const optionsControlEntity = value;
      commit("setComplaintOptions", { optionsControlEntity });
    });
    conditions.then((value) => {
      const optionsConditions = value;
      commit("setComplaintOptions", { optionsConditions });
    });
    companies.then((value) => {
      const optionsCompanies = value;
      commit("setComplaintOptions", { optionsCompanies });
    });
    optionsCompanyEmisor.then((value) => {
      const optionsCompanyEmisor = value;
      commit("setComplaintOptions", { optionsCompanyEmisor });
    });
    optionsTypeValueEmisor.then((value) => {
      const optionsTypeValueEmisor = value;
      commit("setComplaintOptions", { optionsTypeValueEmisor });
    });
    optionsReasonsEmisor.then((value) => {
      const optionsReasonsEmisor = value;
      commit("setComplaintOptions", { optionsReasonsEmisor });
    });
    optionsTypeAnalisis.then((value) => {
      const optionTypeAnalisis = value;
      commit("setComplaintOptions", { optionTypeAnalisis });
    });
    optionsTypeMlValidation.then((value) => {
      const optionTypeMlValidation = value;
      commit("setComplaintOptions", { optionTypeMlValidation });
    });
    optionsStatesSolip.then((value) => {
      let transformedArray = value.map((item) => ({
        id: item.status,
        name: item.status,
      }));
      commit("setComplaintOptions", { optionsStatesSolip: transformedArray });
    });
    optionsStatesAnnexesSolip.then((value) => {
      let transformedArray = value.map((item) => ({
        id: item.status,
        name: item.status,
      }));
      commit("setComplaintOptions", {
        optionsStatesAnnexesSolip: transformedArray,
      });
    });
    optionsTypeRequestSolip.then((value) => {
      let transformedArray = value.map((item) => ({
        id: item.bigquery_field,
        name: item.name,
      }));
      commit("setComplaintOptions", {
        optionsTypeRequestSolip: transformedArray,
      });
    });
    entityTypes.then((value) => {
      const optionsEntityType = value;
      commit("setComplaintOptions", { optionsEntityType });
    });
    mannedCheckpoints.then((value) => {
      const optionsMannedCheckpoint = value;
      commit("setComplaintOptions", { optionsMannedCheckpoint });
    });
    optionsWithdrawAgiliza.then((value) => {
      const optionWithdrawAgiliza = value;
      commit("setComplaintOptions", { optionWithdrawAgiliza });
    });
    optionsAllCompanies.then((value) => {
      const optionAllCompanies = value;
      commit("setComplaintOptions", { optionAllCompanies });
    });
    radicatorProfiles.then((value) => {
      const optionsRadicatorProfile = value;
      commit("setComplaintOptions", { optionsRadicatorProfile });
    });
    solitudeDpHd.then((value) => {
      const optionsSolitudeDpHd = value;
      commit("setComplaintOptions", { optionsSolitudeDpHd });
    });
    statesEmisor.then((value) => {
      let transformedArray = value.map((item) => ({
        id: item.id,
        name: item.name
      }));
      commit("setComplaintOptions", {
        optionsStatesEmisor: transformedArray,
      });
    });
    options_lgbtiq.then((value) => {
      const optionsLgbtiq = value;
      commit("setComplaintOptions", { optionsLgbtiq });
    });
  },
  // Load all form options for DASHBOARD registration with TOKEN
  loadDashboardOptions({ commit, dispatch }) {
    let baseUrl = this._vm.$apiBase.defaults.baseURL;
    let criterions = dispatch("loadOptions", {
      url: baseUrl + "/api/criterion/",
      auth: true,
    });
    let positions = dispatch("loadOptions", {
      url: baseUrl + "/api/position/",
      auth: true,
    });
    let groupCompany = dispatch("loadOptions", {
      url: baseUrl + "/api/group/",
      auth: true,
    });
    let companyType = dispatch("loadOptions", {
      url: baseUrl + "/api/companytype/",
      auth: true,
    });
    let directions = dispatch("loadOptions", {
      url: baseUrl + `/api/direction/`,
      auth: true,
    });
    let reception = dispatch("loadOptions", {
      url: baseUrl + `/api/instance/`,
      auth: true,
    });
    let fraud_types = dispatch("loadOptions", {
      url: baseUrl + `/api/fraud_types/`,
      auth: true,
    });
    let fraud_modes = dispatch("loadOptions", {
      url: baseUrl + `/api/fraud_modes/`,
      auth: true,
    });
    let entity_types = dispatch("loadOptions", {
      url: baseUrl + `/api/companyemisorestype/`,
      auth: true,
    });
    let manned_checkpoints = dispatch("loadOptions", {
      url: baseUrl + `/api/companyemisorescontrol/`,
      auth: true,
    });
    let radicator_profiles = dispatch("loadOptions", {
      url: baseUrl + `/api/radicatorprofile_options/`,
      auth: true,
    });
    let options_solitudeDpHd = dispatch("loadOptions", {
      url: baseUrl + "/api/jurisdiccional-servi/solicitude_type",
      auth: true,
    });
    let options_all_companies = dispatch("loadOptions", {
      url: baseUrl + "/api/company_list/",
      auth: true,
    });
    let options_available_day = dispatch("loadOptions", {
      url: baseUrl + "/api/available_day/",
      auth: true,
    });
    let options_session_duration_agiliza = dispatch("loadOptions", {
      url: baseUrl + "/api/session-duration/",
      auth: true,
    });
    let options_states_facilitators = dispatch("loadOptions", {
      url: baseUrl + "/api/facilitator-state-choices/",
      auth: true,
    });
    let options_lgbtiq = dispatch("loadOptions", {
      url: baseUrl + "/api/lgbtiq-choices/",
      auth: true,
    });
    let options_states_sessions_facilitator = dispatch("loadOptions", {
      url: baseUrl + "/api/session-state/?actor=mediador",
      auth: true,
    });
    let options_states_sessions_cf = dispatch("loadOptions", {
      url: baseUrl + "/api/session-state/?actor=cf",
      auth: true,
    });
    let options_states_sessions_ev = dispatch("loadOptions", {
      url: baseUrl + "/api/session-state/?actor=ev",
      auth: true,
    });
    let options_type_notify_sfc = dispatch("loadOptions", {
      url: baseUrl + "/api/alerts/sfc_type_alert/",
      auth: true,
    });
    let options_state_notifications = dispatch("loadOptions", {
      url: baseUrl + "/api/alerts/cf_status_options/",
      auth: true,
    });

    Promise.allSettled([
      criterions,
      positions,
      groupCompany,
      companyType,
      directions,
      reception,
      fraud_types,
      fraud_modes,
      entity_types,
      manned_checkpoints,
      radicator_profiles,
      options_solitudeDpHd,
      options_all_companies,
      options_available_day,      
      options_session_duration_agiliza,
      options_states_facilitators,
      options_states_sessions_facilitator,
      options_states_sessions_cf,
      options_states_sessions_ev,
      options_type_notify_sfc,
      options_state_notifications,
      options_lgbtiq
    ])
      .then((response) => {
        let optionsCriterions = response[0].value;
        let optionsPosition = response[1].value;
        let optionsGroupCompany = response[2].value;
        let optionsCompanyType = response[3].value;
        let optionsDirections = response[4].value;
        let optionsReception = response[5].value;
        let optionsFraudTypes = response[6].value;
        let optionsFraudModes = response[7].value;
        let optionsEntityType = response[8].value;
        let optionsMannedCheckpoint = response[9].value;
        let optionsRadicatorProfile = response[10].value;
        let optionsSolitudeDpHd = response[11].value;
        let optionsAllCompanies = response[12].value;
        let optionsAvailableDay = response[13].value;
        let optionsSessionDurationAgiliza = response[14].value;
        let optionsStatesFacilitators = response[15].value;
        let optionsStatesSessionsFacilitator = response[16].value;
        let optionsStatesSessionsCf = response[17].value;
        let optionsStatesSessionsEv = response[18].value;
        let optionsTypeNotifySfc = response[19].value;
        let optionsStateNotifications = response[20].value;
        let optionsLgbtiq = response[21].value;

        commit("setDashboardOptions", {
          optionsCriterions,
          optionsPosition,
          optionsGroupCompany,
          optionsCompanyType,
          optionsDirections,
          optionsReception,
          optionsFraudTypes,
          optionsFraudModes,
          optionsEntityType,
          optionsMannedCheckpoint,
          optionsRadicatorProfile,
          optionsSolitudeDpHd,
          optionsAllCompanies,
          optionsAvailableDay,
          optionsSessionDurationAgiliza,
          optionsStatesFacilitators,
          optionsStatesSessionsFacilitator,
          optionsStatesSessionsCf,
          optionsStatesSessionsEv,
          optionsTypeNotifySfc,
          optionsStateNotifications,
          optionsLgbtiq
        });
      })
      .catch((error) => console.error(error.response));
  },

  loadAllCompaniesOptions({ dispatch }) {
    let baseUrl = this._vm.$apiBase.defaults.baseURL;
    let url = `/api/company_list/`;
    let allCompanies = dispatch("loadOptions", {
      url: baseUrl + url,
      auth: true,
    });
    return allCompanies.then((response) => {
      return response;
    });
  },

  // Load municipalities options by id department
  async loadMunicipalitiesOptions({ dispatch }, payload) {
    if (payload.department == null || payload.department == undefined) return;
    let baseUrl = this._vm.$apiBase.defaults.baseURL;
    let url = `/api/municipality/?department=${payload.department}`;
    let municipalities = dispatch("loadOptions", {
      url: baseUrl + url,
      auth: true,
    });
    return municipalities.then((response) => {
      let optionsMunicipalities = response.map((item) => {
        return {
          ...item,
          id: item.code,
        };
      });
      return optionsMunicipalities;
    });
  },
  // Load reasons options by id company
  loadReasonsOptions({ dispatch }, payload) {
    if (payload.company == null || payload.company == undefined) return;
    let baseUrl = this._vm.$apiBase.defaults.baseURL;
    let url = `/api/reason/company/?id_company=${payload.company}`;
    let reasons = dispatch("loadOptions", { url: baseUrl + url, auth: true });
    return reasons.then((response) => {
      return response;
    });
  },

  // Load All reasons emisores
  loadAllReasonsEmisorOptions({ dispatch }) {
    let baseUrl = this._vm.$apiBase.defaults.baseURL;
    let url = `/api/reasons-emisores/`;
    let reasonsEmisor = dispatch("loadOptions", {
      url: baseUrl + url,
      auth: true,
    });
    return reasonsEmisor.then((response) => {
      return response;
    });
  },
  // Load reasons options by type value
  loadReasonsEmisorOptions({ dispatch }, payload) {
    if (
      payload.type_value_emisor == null ||
      payload.type_value_emisor == undefined
    )
      return;
    let baseUrl = this._vm.$apiBase.defaults.baseURL;
    let url = `/api/reasons-emisores/?tipo_valor_id=${payload.type_value_emisor}`;
    let reasonsEmisor = dispatch("loadOptions", {
      url: baseUrl + url,
      auth: true,
    });
    return reasonsEmisor.then((response) => {
      return response;
    });
  },

  loadReasonsAgilizaOptions({ dispatch }) {
    let baseUrl = this._vm.$apiBase.defaults.baseURL;
    let url = `/api/reason/?is_agiliza_reason=true`;
    let reasonsAgiliza = dispatch("loadOptions", {
      url: baseUrl + url,
      auth: true,
    });
    return reasonsAgiliza.then((response) => {
      return response;
    });
  },

  loadReasonsOpt({ dispatch }) {
    let baseUrl = this._vm.$apiBase.defaults.baseURL;
    let url = `/api/reason/`;
    let reasons = dispatch("loadOptions", { url: baseUrl + url, auth: true });
    return reasons.then((response) => {
      return response;
    });
  },

  loadStatesOpt({ dispatch }) {
    let baseUrl = this._vm.$apiBase.defaults.baseURL;
    let url = `/api/state/`;
    let reasons = dispatch("loadOptions", { url: baseUrl + url, auth: true });
    return reasons.then((response) => {
      return response;
    });
  },

  loadStatesAgilizaOpt({ dispatch }, payload) {
    let baseUrl = this._vm.$apiBase.defaults.baseURL;
    let url = `/api/state-agiliza/?actor=${payload.actor}`;
    let reasons = dispatch("loadOptions", { url: baseUrl + url, auth: true });
    return reasons.then((response) => {
      return response;
    });
  },

  loadStatesAgilizaOpt({ dispatch }, payload) {
    let baseUrl = this._vm.$apiBase.defaults.baseURL;
    let url = `/api/state-agiliza/?actor=${payload.actor}`;
    let reasons = dispatch("loadOptions", { url: baseUrl + url, auth: true });
    return reasons.then((response) => {
      return response;
    });
  },

  // Load session duration options
  loadSessionDurationOptions({ dispatch }) {
    let baseUrl = this._vm.$apiBase.defaults.baseURL;
    let url = '/api/session-duration/';
    let sessionDuration = dispatch("loadOptions", { url: baseUrl + url, auth: true });
    return sessionDuration.then((response) => {
      return response;
    });
  },

    // Load products options by id company
  loadProductsOptions({ dispatch }, payload) {
    if (payload.company == null || payload.company == undefined) return;

    let baseUrl = this._vm.$apiBase.defaults.baseURL;
    let url = `/api/product/company/?id_company=${payload.company}`;
    let reasons = dispatch("loadOptions", { url: baseUrl + url, auth: true });
    return reasons.then((response) => {
      return response;
    });
  },
  
  // Load options with pagination
  async loadOptions(context, payload) {
    try {
      // To_Do: Reevaluar si está lógica es necesaria para el funcionamiento general
      let values = [];
      while (payload.url) {
        let url = payload.url;
        url = "/api" + url.split("/api")[1];
        const response = await this._vm.$apiBase(url);
        const { results, next } = response.data;
        values.push(...results);
        payload.url = next;
      }
      return values;
    } catch (e) {
      console.error(e);
      return [];
    }
  },
  loadListOptions({ commit, dispatch }, payload) {
    if (payload == null || payload == undefined) return;
    let baseUrl = this._vm.$apiBase.defaults.baseURL;
    let url = `/api/${payload.endpoint}`;
    dispatch("loadOptions", { url: baseUrl + url, auth: true }).then(
      (response) => {
        commit("setListOptions", {
          listName: payload.name,
          listData: response,
        });
      },
    );
  },
  loadWithdraw({ dispatch }) {
    let baseUrl = this._vm.$apiBase.defaults.baseURL;
    let url = `/api/complaint-agiliza-cancelation/`;
    let withdrawReasons = dispatch("loadOptions", {
      url: baseUrl + url,
      auth: true,
    });
    return withdrawReasons.then((response) => {
      return response;
    });
  },
};

const form = {
  namespaced: true,
  state,
  mutations,
  actions,
};

export default form;
